import * as THREE from '../build/three.module.js';
import { Utils } from '../utils/Utils.js';
import Navigator from './Navigator.js';

export default class Step extends THREE.Group {

    constructor() {
        super();
    }

    on(){

    }

    onComplete(){

    }

    off(){

    }

    next(){
        Navigator.INSTANCE.events.onNextStep.dispatch();
    }

    offComplete(){
        this.clear();
        Navigator.INSTANCE.events.onStepOffComplete.dispatch();
    }

    update(){

    }

    clear(){

    }
}

export { Step };
